import React from 'react';
import { Tabs, Stack, Paper, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IconBellRinging, IconBellCheck, IconBuilding } from '@tabler/icons-react';
import WrappedAlertTable from './AlertTable';
import WrappedResolvedAlertTable from './ResolvedAlertTable';
import WrappedClinicAlertTable from './ClinicAlertTable';
import classes from '../../HcpPatientDashboard/Graph/tab.module.css';
import { useSessionProvider } from '../../../global/provider/sessionContext.tsx';

const TabbedAlertView: React.FC = () => {
    const { t } = useTranslation();
    const { currentUser } = useSessionProvider();

    const hasClinic = !!currentUser?.selectedHealthcareFacilityID;

    return (
        <Stack gap={'lg'} pt={'xl'} h="100%" w="100%">
            <Title c="black" order={3}>
                {t('alert.alerts')}
            </Title>
            <Tabs defaultValue="active" classNames={classes}>
                <Tabs.List>
                    <Tabs.Tab
                        value="active"
                        leftSection={<IconBellRinging size={16} />}
                    >
                        {t('alert.summary.active')}
                    </Tabs.Tab>
                    <Tabs.Tab
                        value="resolved"
                        leftSection={<IconBellCheck size={16} />}
                    >
                        {t('alert.summary.resolved')}
                    </Tabs.Tab>
                    {hasClinic && (
                        <Tabs.Tab
                            value="clinic"
                            leftSection={<IconBuilding size={16} />}
                        >
                            {t('alert.clinicAlerts')}
                        </Tabs.Tab>
                    )}
                </Tabs.List>

                <Tabs.Panel value="active">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedAlertTable />
                    </Paper>
                </Tabs.Panel>

                <Tabs.Panel value="resolved">
                    <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                        <WrappedResolvedAlertTable />
                    </Paper>
                </Tabs.Panel>

                {hasClinic && (
                    <Tabs.Panel value="clinic">
                        <Paper p="md" shadow="xs" style={{ width: '100%', borderRadius: '0 0 10px 10px' }}>
                            <WrappedClinicAlertTable />
                        </Paper>
                    </Tabs.Panel>
                )}
            </Tabs>
        </Stack>
    );
};

export default TabbedAlertView;
